import { createAction } from '@reduxjs/toolkit'
import { CoinExType } from '../../api/swap/klineData'

export const setZIndex = createAction<{ zIndex: number }>('quotes/setZIndex')
export const setCoinInfo = createAction<{ coinInfo: CoinExType }>('quotes/setCoinInfo')
